import { render, staticRenderFns } from "./bgSkeletonSSO.vue?vue&type=template&id=19c44a9e&scoped=true"
import script from "./bgSkeletonSSO.vue?vue&type=script&lang=js"
export * from "./bgSkeletonSSO.vue?vue&type=script&lang=js"
import style0 from "./bgSkeletonSSO.vue?vue&type=style&index=0&id=19c44a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c44a9e",
  null
  
)

export default component.exports